import { useContext, useState } from "react";
import { ToastContext, ToastTypeEnum } from "context/toastContext";
import typography from "constants/typography.constants";
import downloadFileWithAuthRetry from "helpers/fetch/downloadFileWithAuthRetry";

const useDownloadCompetencyMap = () => {
  const { addToast } = useContext(ToastContext);
  const [isLoading, setIsLoading] = useState(false);

  const getCompetencyMapFile = async (competencyMap: { id: string; title: string } | undefined | null) => {
    if (competencyMap) {
      setIsLoading(true);
      await downloadFileWithAuthRetry({
        url: `${process.env.REACT_APP_API_URL}/competency-map/download-xlsx?competencyMapId=${competencyMap.id}`,
        filename: `${competencyMap.title}.xlsx`,
        addToast,
      });
      setIsLoading(false);
    } else {
      addToast({ text: typography.errors.pleaseRepeat, type: ToastTypeEnum.ERROR });
    }
  };

  return { getCompetencyMapFile, isLoading };
};

export default useDownloadCompetencyMap;
